import type { FC } from 'react';
import ContentLoader from 'react-content-loader';

import { createArray } from 'app/utils/array';

import style from './style.scss';

interface Props {
  nbEvents?: number;
}

const CIRCLE_RADIUS = 8;

const MatchListPlaceholder: FC<Props> = ({ nbEvents = 3 }) => (
  <div>
    {createArray(nbEvents).map((_, index) => (
      <div key={index} className={style.container}>
        <ContentLoader width={916} height={84}>
          <rect x={17} y={31} width={24} height={22} />

          <rect x={60} y={15} width={121} height={14} />
          <rect x={201} y={15} width={651} height={14} />

          <rect x={62} y={42} width={838} height={1} />

          <rect x={60} y={54} width={121} height={14} />
          <rect x={201} y={54} width={110} height={14} />
          <circle cx={332} cy={61} r={CIRCLE_RADIUS} />
          <circle cx={390} cy={61} r={CIRCLE_RADIUS} />
          <rect x={414} y={54} width={110} height={14} />
        </ContentLoader>
      </div>
    ))}
  </div>
);

MatchListPlaceholder.displayName = 'MatchListPlaceholder';

export default MatchListPlaceholder;
